import React, { useEffect, useState, useRef } from "react";
import { secretKey, monthData } from "../.././data";
import LeadPopUp from "./lead_popup.js";
import MultiSelectNew from "./multiSelect2.js";
import EditLeadOwner from "./editLeadOwner.js";
import EditLeadOwnerMain from "./editLeadOwnerMain.js";
import { faEdit, faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import StatisticsLeads from "./statisticsLeads.js";
import Loading from "../helpers/loading_component.js";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const MySwal = withReactContent(Swal2);

const SellSystemLeads = (props) => {
  const [showStatistics, setShowStatistics] = useState(false);
  const [loading, setLoading] = useState(true);
  const [leads, setLeads] = useState([]);
  const [leadSource, setLeadSource] = useState([]);
  const [banks, setBanks] = useState([]);
  const [leadsClear, setLeadsClear] = useState([]);
  const [leadId, setLeadId] = useState("");
  const [userSearch, setUserSearch] = useState("");
  const [sourceSearch, setSourceSearch] = useState("");
  const [bankSearch, setBankSearch] = useState("");
  const [statusSearch, setStatusSearch] = useState("");
  const [typeSearch, setTypeSearch] = useState("");
  const [wideSearch, setWideSearch] = useState("");
  const [idSearch, setIdSearch] = useState("");
  const [page, setPage] = useState("1");
  const [perPage, setPerPage] = useState("200");
  const [leadC, setLeadC] = useState("");
  const [sort, setSort] = useState("");
  const [users, setUsers] = useState([]);
  const [sellStatus, setSellStatus] = useState([]);
  const [showLeadPopUp, setShowLeadPopUp] = useState(false);
  const [filterDuplicate, setFilterDuplicate] = useState(false);
  const [filterNotAssigned, setFilterNotAssigned] = useState(false);
  const [filterDocuments, setFilterDocuments] = useState(false);
  const [isHoveringUser, setIsHoveringUser] = useState(false);
  const [isHoveringSource, setIsHoveringSource] = useState(false);
  const [isHoveringStatus, setIsHoveringStatus] = useState(false);
  const [isHoveringType, setIsHoveringType] = useState(false);
  const [isHoveringBank, setIsHoveringBank] = useState(false);
  const [selectedOptionsUser, setSelectedOptionsUser] = useState([]);
  const [selectedOptionsSource, setSelectedOptionsSource] = useState([]);
  const [selectedOptionsStatus, setSelectedOptionsStatus] = useState([]);
  const [selectedOptionsType, setSelectedOptionsType] = useState([]);
  const [selectedOptionsBank, setSelectedOptionsBank] = useState([]);
  const [showAddLeadOwner, setShowAddLeadOwner] = useState(false);
  const [showEditLeadOwner, setShowEditLeadOwner] = useState(false);
  const [editLeadOwnerId, setEditLeadOwnerId] = useState("");
  const [dateAddLeadFrom, setDateAddLeadFrom] = useState("");
  const [dateAddLeadTo, setDateAddLeadTo] = useState("");
  const [addDateFilter, setAddDateFilter] = useState(false);
  const [dateAssLeadFrom, setDateAssLeadFrom] = useState("");
  const [dateAssLeadTo, setDateAssLeadTo] = useState("");
  const [assDateFilter, setAssDateFilter] = useState(false);
  const [dateCSLeadFrom, setDateCSLeadFrom] = useState("");
  const [dateCSLeadTo, setDateCSLeadTo] = useState("");
  const [csDateFilter, setCSDateFilter] = useState(false);
  const [expandMobileFilters, setExpandMobileFilters] = useState(false);
  const [arrToClose, setArrToClose] = useState([]);
  const [leadsTasks, setLeadsTasks] = useState([]);
  const [leadsContacts, setLeadsContacts] = useState([]);
  const [leadsDocs, setLeadsDocs] = useState([]);

  const getNValue = () => {
    if (+page === 1) {
      return 0;
    } else {
      return +page * +perPage - +perPage;
    }
  };

  const getValue = () => {
    if (+page === 1) {
      return 200;
    } else {
      return +page * +perPage + +perPage - +perPage;
    }
  };

  const handleAddPage = () => {
    if (+page * +perPage < leads.length) {
      setPage(+page + 1);
    }
  };

  const handleSubPage = () => {
    if (+page > 1) {
      setPage(+page - 1);
    }
  };

  const fetchUsers = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
        fetchLeads();
      })
      .catch((error) => {});
  };

  const fetchLeads = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLeads", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data =
          props.user.adminSprzedaz === "1"
            ? data
            : props.user.role === "consultantTele"
            ? data.filter((el) => el.status !== "zamknięty")
            : data.filter(
                (el) =>
                  el.owner === props.user.name || el.support === props.user.name
              );

        fetchLeadSource();

        fetchLeadDocs(data);
      })
      .catch((error) => {});
  };

  const fetchLeadDocs = async (leads) => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLeadsDocs", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLeadsDocs(data);
        var arr = leads;
        arr.map((lead) => {
          lead.docs =
            data.filter((el) => +el.id === +lead.id).length > 0
              ? data.filter((el) => el.id === lead.id)[0].docs
              : "";
        });
        fetchLeadTasks(arr.filter((el) => +el.docs > 0));
      })
      .catch((error) => {});
  };

  const fetchLeadTasks = async (leads) => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLeadsTasks", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLeadsTasks(data);
        var arr = leads;
        arr.map((lead) => {
          lead.lastTask =
            data.filter((el) => +el.id === +lead.id).length > 0
              ? data.filter((el) => el.id === lead.id)[0].lastTask
              : "";
        });

        fetchLeadContacts(arr);
      })
      .catch((error) => {});
  };

  const fetchLeadContacts = async (leads) => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLeadsTasks", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLeadsContacts(data);
        var arr = leads;
        arr.map((lead) => {
          lead.lastContact =
            data.filter((el) => el.id === lead.id).length > 0
              ? data.filter((el) => el.id === lead.id)[0].lastContact
              : "";
        });

        setLeads(arr);
        setLeadsClear(arr);

        handleSortChangeRefresh(sort);
        handleFilterChangeRefresh("", "", arr);
      })
      .catch((error) => {});
  };

  const fetchLeadSource = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLeadSource", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLeadSource(data);
        fetchStatus();
      })
      .catch((error) => {});
  };

  const fetchStatus = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getSellStatus", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSellStatus(data);
        fetchBanks();
      })
      .catch((error) => {});
  };

  const getBanksForTeam = (data) => {
    var usersForTeam = [];

    data.map((el) => {
      if (el.team.split(",").filter((el2) => +el2 === 1).length > 0) {
        usersForTeam.push(el);
      }
    });

    return usersForTeam;
  };

  const fetchBanks = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getBanks", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setBanks(getBanksForTeam(data));
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchUsers();
  };

  useEffect(() => {
    getData();
  }, []);

  const handleShowAddLeadOwner = () => {
    setShowAddLeadOwner(true);
  };

  const handleCloseAddLeadOwner = () => {
    setShowAddLeadOwner(false);
    getData();
  };

  const handleRowClick = (e) => {
    e.preventDefault();
    var value = e.currentTarget.attributes.value.value;
    setLeadId(value);
    setLeadC(leads.filter((el) => +el.id === +value)[0]);
    setShowLeadPopUp(true);
  };

  const closeLeadPopUp = () => {
    setShowLeadPopUp(false);
    setLeadId("");
    setLeadC("");
    getData();
  };

  const getInitials = (user) => {
    var newData = users.filter((el) => el.name === user);
    if (newData.length > 0) {
      return newData[0].initials;
    } else {
      return "";
    }
  };

  const handleShowStatistics = () => {
    setShowStatistics(true);
  };

  const closeStatistics = () => {
    setShowStatistics(false);
    getData();
  };

  const getUserOptions = (e) => {
    var arr = [];
    arr.push({ label: "Wszyscy", value: "all" });
    arr.push({ label: "Nieprzypisani", value: "" });

    users
      .filter((el) => el.sprzedaz === "1")
      .map((el) => {
        var opt = { label: el.initials, value: el.name };
        arr.push(opt);
      });

    if (props.user.role === "consultantTele") {
      arr = [];
      arr.push({ label: "Wszyscy", value: "all" });
      users
        .filter((el) => el.role === "consultantTele")
        .map((el) => {
          var opt = { label: el.initials, value: el.name };
          arr.push(opt);
        });
    }

    return arr;
  };

  const getSourceOptions = (e) => {
    var arr = [];

    leadSource.map((el) => {
      var opt = { label: el.name, value: el.name };
      arr.push(opt);
    });

    return arr;
  };

  const getBanksOptions = (e) => {
    var arr = [];
    arr.push({ label: "Wszystkie", value: "all" });
    arr.push({ label: "Brak danych", value: "" });

    banks.map((el) => {
      var opt = { label: el.name, value: el.name };
      arr.push(opt);
    });

    return arr;
  };

  const getStatusOptions = (e) => {
    var arr = [];
    arr.push({ label: "Wszystkie", value: "all" });

    sellStatus.map((el) => {
      var opt = { label: el.status, value: el.status };
      arr.push(opt);
    });

    return arr;
  };

  const getTypeOptions = (e) => {
    var arr = [];
    arr.push({ label: "Wszystkie", value: "all" });
    arr.push({ label: "CHF", value: "CHF" });
    arr.push({ label: "EUR", value: "EURO" });
    arr.push({ label: "USD", value: "USD" });
    arr.push({ label: "SKD", value: "SKD" });
    arr.push({ label: "WIBOR", value: "WIBOR" });

    return arr;
  };

  const createExcelDS = () => {
    var tab = [];
    tab.push([
      "ID",
      "Imię i nazwisko",
      "Numer telefonu",
      "Adres e-mail",
      "Bank",
      "Wysokość kredytu",
      "Data wypłaty kredytu",
      "Waluta kredytu",
      "Umowa kredytowa",
      "Długość kredytu",
      "Data całkowitej spłaty kredytu",
      "Źródło",
      "Stauts",
      "Data zmiany statusu",
      "Data dodania",
      "Pracownik dodający",
      "Prawnik przypisany",
      "Rodzaj",
      "Notatka",
    ]);
    leads.map((el) => {
      tab.push([
        el.id,
        el.name,
        el.phone,
        el.mail,
        el.bank,
        el.creditAmmount,
        el.creditDate,
        el.creditCurrency,
        el.creditAgreement,
        el.creditLength,
        el.creditEnd,
        el.source,
        el.status,
        el.changeStatus,
        el.addDate,
        el.addUser,
        el.owner,
        el.type,
        el.note,
      ]);
    });
    return tab;
  };

  const exportToExcel = (e) => {
    const worksheet = XLSX.utils.json_to_sheet(createExcelDS());
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dane");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "dane.xlsx");
  };

  const handleUserSearchChange = (e) => {
    setUserSearch(e);
    handleFilterChange("user", e);
  };

  const handleWideSearchChange = (e) => {
    setWideSearch(e.target.value);
    handleFilterChange("wide", e.target.value);
  };

  const handleIdSearchChange = (e) => {
    setIdSearch(e.target.value);
    handleFilterChange("id", e.target.value);
  };

  const handleSourceSearchChange = (e) => {
    setSourceSearch(e);
    handleFilterChange("source", e);
  };

  const handleStatusSearchChange = (e) => {
    setStatusSearch(e);
    handleFilterChange("status", e);
  };

  const handleTypeSearchChange = (e) => {
    setTypeSearch(e);
    handleFilterChange("type", e);
  };

  const handleBankSearchChange = (e) => {
    setBankSearch(e);
    handleFilterChange("bank", e);
  };

  const checkOption = (arr, value) => {
    if (arr.filter((el) => el === value).length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const handleShowEditLeadOwner = (e) => {
    setEditLeadOwnerId(
      leadsClear.filter((el) => +el.id === +e.currentTarget.value)[0]
    );
    setShowEditLeadOwner(true);
  };

  const handleFilterChange = (type, value) => {
    setPage(1);
    var arr = leadsClear;

    var userFilterValue = type === "user" ? value : userSearch;
    if (userFilterValue.length > 0) {
      arr = arr.filter((el) => checkOption(userFilterValue, el.owner));
    }

    var sourceFilterValue = type === "source" ? value : sourceSearch;
    if (sourceFilterValue.length > 0) {
      arr = arr.filter((el) => checkOption(sourceFilterValue, el.source));
    }

    var statusFilterValue = type === "status" ? value : statusSearch;
    if (statusFilterValue.length > 0) {
      arr = arr.filter((el) => checkOption(statusFilterValue, el.status));
    }

    var typeFilterValue = type === "type" ? value : typeSearch;
    if (typeFilterValue.length > 0) {
      arr = arr.filter((el) => checkOption(typeFilterValue, el.type));
    }

    var wideFilterValue = type === "wide" ? value : wideSearch;
    if (wideFilterValue.length > 0) {
      arr = arr.filter(
        (el) =>
          el.name.toString().toLowerCase().includes(wideFilterValue) ||
          el.mail.toString().toLowerCase().includes(wideFilterValue) ||
          el.phone.toString().toLowerCase().includes(wideFilterValue)
      );
    }

    var idFilterValue = type === "id" ? value : idSearch;
    if (idFilterValue.length > 0) {
      arr = arr.filter((el) => +el.id === +idFilterValue);
    }

    if (type === "addDate" ? value : addDateFilter) {
      arr = arr.filter(
        (el) =>
          new Date(new Date(el.addDate).setHours(0, 0, 0)) >=
            new Date(new Date(dateAddLeadFrom).setHours(0, 0, 0)) &&
          new Date(new Date(el.addDate).setHours(0, 0, 0)) <=
            new Date(new Date(dateAddLeadTo).setHours(0, 0, 0))
      );
    }

    if (type === "assDate" ? value : assDateFilter) {
      arr = arr
        .filter((el1) => el1.assignDate !== null)
        .filter(
          (el) =>
            new Date(new Date(el.assignDate).setHours(0, 0, 0)) >=
            new Date(new Date(dateAssLeadFrom).setHours(0, 0, 0))
        );
    }

    if (type === "csDate" ? value : csDateFilter) {
      arr = arr.filter(
        (el) =>
          new Date(new Date(el.changeStatus).setHours(0, 0, 0)) >=
            new Date(new Date(dateCSLeadFrom).setHours(0, 0, 0)) &&
          new Date(new Date(el.changeStatus).setHours(0, 0, 0)) <=
            new Date(new Date(dateCSLeadTo).setHours(0, 0, 0))
      );
    }

    var bankFilterValue = type === "bank" ? value : bankSearch;
    if (bankFilterValue.length > 0) {
      arr = arr.filter((el) => checkOption(bankFilterValue, el.bank));
    }

    if (type === "duplicate" ? value : filterDuplicate) {
      var test = "0";
      if (filterDuplicate === false) {
        test = "1";
      } else {
        test = "0";
      }
      arr = arr.filter((el) => el.duplicate === test);
    }

    if (type === "notassigned" ? value : filterNotAssigned) {
      arr = arr.filter((el) => !(+el.owner.length > 0));
    }

    if (type === "documents" ? value : filterDocuments) {
      arr = arr.filter((el) => +el.docs > 0);
    }

    setLeads(arr);
  };

  const handleFilterChangeRefresh = (type, value, data) => {
    var arr = data;

    var userFilterValue = type === "user" ? value : userSearch;
    if (userFilterValue.length > 0) {
      arr = arr.filter((el) => checkOption(userFilterValue, el.owner));
    }

    var sourceFilterValue = type === "source" ? value : sourceSearch;
    if (sourceFilterValue.length > 0) {
      arr = arr.filter((el) => checkOption(sourceFilterValue, el.source));
    }

    var statusFilterValue = type === "status" ? value : statusSearch;
    if (statusFilterValue.length > 0) {
      arr = arr.filter((el) => checkOption(statusFilterValue, el.status));
    }

    var typeFilterValue = type === "type" ? value : typeSearch;
    if (typeFilterValue.length > 0) {
      arr = arr.filter((el) => checkOption(typeFilterValue, el.type));
    }

    var wideFilterValue = type === "wide" ? value : wideSearch;
    if (wideFilterValue.length > 0) {
      arr = arr.filter(
        (el) =>
          el.name.toString().toLowerCase().includes(wideFilterValue) ||
          el.mail.toString().toLowerCase().includes(wideFilterValue) ||
          el.phone.toString().toLowerCase().includes(wideFilterValue)
      );
    }

    var idFilterValue = type === "id" ? value : idSearch;
    if (idFilterValue.length > 0) {
      arr = arr.filter((el) => +el.id === +idFilterValue);
    }

    var bankFilterValue = type === "bank" ? value : bankSearch;
    if (bankFilterValue.length > 0) {
      arr = arr.filter((el) => checkOption(bankFilterValue, el.bank));
    }

    if (type === "addDate" ? value : addDateFilter) {
      arr = arr.filter(
        (el) =>
          new Date(new Date(el.addDate).setHours(0, 0, 0)) >=
            new Date(new Date(dateAddLeadFrom).setHours(0, 0, 0)) &&
          new Date(new Date(el.addDate).setHours(0, 0, 0)) <=
            new Date(new Date(dateAddLeadTo).setHours(0, 0, 0))
      );
    }

    if (type === "assDate" ? value : assDateFilter) {
      arr = arr.filter(
        (el) =>
          new Date(new Date(el.assignDate).setHours(0, 0, 0)) >=
            new Date(new Date(dateAssLeadFrom).setHours(0, 0, 0)) &&
          new Date(new Date(el.assignDate).setHours(0, 0, 0)) <=
            new Date(new Date(dateAssLeadTo).setHours(0, 0, 0))
      );
    }

    if (type === "csDate" ? value : csDateFilter) {
      arr = arr.filter(
        (el) =>
          new Date(new Date(el.changeStatus).setHours(0, 0, 0)) >=
            new Date(new Date(dateCSLeadFrom).setHours(0, 0, 0)) &&
          new Date(new Date(el.changeStatus).setHours(0, 0, 0)) <=
            new Date(new Date(dateCSLeadTo).setHours(0, 0, 0))
      );
    }

    if (type === "duplicate" ? value : filterDuplicate) {
      var test = "0";
      if (filterDuplicate === false) {
        test = "1";
      } else {
        test = "0";
      }
      arr = arr.filter((el) => el.duplicate === test);
    }

    if (type === "documents" ? value : filterDocuments) {
      arr = arr.filter((el) => +el.docs > 0);
    }

    if (type === "notassigned" ? value : filterNotAssigned) {
      arr = arr.filter((el) => !(+el.owner.length > 0));
    }

    setLeads(arr);
  };

  const handleSortChange = (e) => {
    setLoading(true);
    if (e.target.value === "sort1") {
      setLeads(
        leads.sort(
          (a, b) =>
            new Date(a.addDate.length === 0 ? "1900-01-01" : a.addDate) -
            new Date(b.addDate.length === 0 ? "1900-01-01" : b.addDate)
        )
      );
    } else if (e.target.value === "sort2") {
      setLeads(
        leads.sort(
          (a, b) =>
            new Date(b.addDate.length === 0 ? "1900-01-01" : b.addDate) -
            new Date(a.addDate.length === 0 ? "1900-01-01" : a.addDate)
        )
      );
    } else if (e.target.value === "sort3") {
      setLeads(leads.sort((a, b) => +a.id - +b.id));
    } else if (e.target.value === "sort4") {
      setLeads(leads.sort((a, b) => +b.id - +a.id));
    } else if (e.target.value === "sort5") {
      setLeads(
        leads.sort(
          (a, b) =>
            new Date(
              a.lastContact.length === 0 || a.lastContact === null
                ? "1900-01-01"
                : a.lastContact
            ) -
            new Date(
              b.lastContact.length === 0 || b.lastContact === null
                ? "1900-01-01"
                : b.lastContact
            )
        )
      );
    } else if (e.target.value === "sort6") {
      setLeads(
        leads.sort(
          (a, b) =>
            new Date(
              b.lastContact.length === 0 || b.lastContact === null
                ? "1900-01-01"
                : b.lastContact
            ) -
            new Date(
              a.lastContact.length === 0 || a.lastContact === null
                ? "1900-01-01"
                : a.lastContact
            )
        )
      );
    }

    setSort(e.target.value);
    setLoading(false);
  };

  const handleSortChangeRefresh = (sortA) => {
    setLoading(true);
    if (sortA === "sort1") {
      setLeads(
        leads.sort(
          (a, b) =>
            new Date(a.addDate.length === 0 ? "1900-01-01" : a.addDate) -
            new Date(b.addDate.length === 0 ? "1900-01-01" : b.addDate)
        )
      );
    } else if (sortA === "sort2") {
      setLeads(
        leads.sort(
          (a, b) =>
            new Date(b.addDate.length === 0 ? "1900-01-01" : b.addDate) -
            new Date(a.addDate.length === 0 ? "1900-01-01" : a.addDate)
        )
      );
    } else if (sortA === "sort3") {
      setLeads(leads.sort((a, b) => +a.id - +b.id));
    } else if (sortA === "sort4") {
      setLeads(leads.sort((a, b) => +b.id - +a.id));
    } else if (sortA === "sort5") {
      setLeads(
        leads.sort(
          (a, b) =>
            new Date(
              a.lastContact.length === 0 || a.lastContact === null
                ? "1900-01-01"
                : a.lastContact
            ) -
            new Date(
              b.lastContact.length === 0 || b.lastContact === null
                ? "1900-01-01"
                : b.lastContact
            )
        )
      );
    } else if (sortA === "sort6") {
      setLeads(
        leads.sort(
          (a, b) =>
            new Date(
              b.lastContact.length === 0 || b.lastContact === null
                ? "1900-01-01"
                : b.lastContact
            ) -
            new Date(
              a.lastContact.length === 0 || a.lastContact === null
                ? "1900-01-01"
                : a.lastContact
            )
        )
      );
    }

    setSort(sortA);
    setLoading(false);
  };

  const scrollTop = (e) => {
    const divToScrollTo = document.getElementById("testScroll");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const scrollBottom = (e) => {
    const divToScrollTo = document.getElementById("testScroll");
    window.scrollTo({
      top: divToScrollTo.clientHeight,
      behavior: "smooth",
    });
  };

  const leadsDataMobile = (
    <>
      <p className="lCounter">Liczba kontaktów: {leads.length}</p>
      <table style={{ marginTop: "0vh" }} className="clients_table">
        <tr key={0}>
          <th style={{ fontSize: "3vw" }}>ID</th>
          <th style={{ fontSize: "3vw" }}>Nazwa</th>
          <th style={{ fontSize: "3vw" }}>Pracownik</th>
          <th style={{ fontSize: "3vw" }}>Bank</th>
          <th style={{ fontSize: "3vw" }}>
            {props.user.salesSuperAdmin === "1"
              ? "Źródło - oryginał"
              : "Źródło"}
          </th>
        </tr>
        {leads.slice(getNValue(), getValue()).map((el, index) => (
          <>
            <tr
              style={el.arch === "1" ? { backgroundColor: "yellow" } : {}}
              id={""}
              key={el.id}
            >
              <td
                value={el.id}
                onClick={handleRowClick}
                style={
                  props.user.adminSprzedaz === "1" && el.duplicate === "1"
                    ? { backgroundColor: "orange", color: "white" }
                    : {}
                }
              >
                {el.id}
              </td>
              <td
                style={{
                  textAlign: "left",
                  paddingLeft: "5px",
                  fontWeight: "600",
                  maxWidth: "15%",
                  wordBreak: "break-word",
                }}
                value={el.id}
                onClick={handleRowClick}
              >
                {el.name}{" "}
              </td>
              <td
                style={{
                  textAlign: "center",
                  paddingLeft: "5px",
                  fontWeight: "400",
                  wordBreak: "break-word",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  border: "0px",
                }}
                value={el.id}
              >
                {el.owner === "" || el.owner === null
                  ? "brak danych"
                  : getInitials(el.owner)}{" "}
                {props.user.adminSprzedaz === "1" ? (
                  <>
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "3vw",
                      }}
                      id="clientsButtonW"
                      className="paymentMenuButton"
                      value={el.id}
                      onClick={handleShowEditLeadOwner}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </>
                ) : (
                  ""
                )}
              </td>

              <td value={el.id} onClick={handleRowClick}>
                {el.bank}
              </td>
              <td value={el.id} onClick={handleRowClick}>
                {props.user.salesSuperAdmin === "1" ? el.realSource : el.source}
              </td>
            </tr>
          </>
        ))}
      </table>
      <div
        style={{
          display: "flex",
          justifyContent: "right",
          width: "100%",
          alignItems: "flex-end",
          marginTop: "5vh",
        }}
        className="searchBoxP"
      >
        <button
          style={{
            backgroundColor: "#00bdce",
            border: "none",
            color: "white",
            fontWeight: "600",
            borderRadius: "15px",
          }}
          id="clientsFilterButton"
          className="paymentMenuButton"
          onClick={scrollTop}
        >
          Przejdź na górę listy
        </button>
      </div>
    </>
  );

  const chooseLead = (e) => {
    var exist = arrToClose.filter((el) => el === e.target.value).length > 0;
    if (exist) {
      var deleteArr = arrToClose.filter((el) => el !== e.target.value);
      setArrToClose(deleteArr);
    } else {
      var addArr = arrToClose;
      addArr.push(e.target.value);
      setArrToClose(addArr);
    }
  };

  const closeManyLeads = async (e) => {
    if (true) {
      setLoading(true);

      var status = "zamknięty";

      arrToClose.map(async (el) => {
        var body = {
          leadId: el,
          value: status,
          reason: "",
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateLeadStatus", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {})
          .catch((error) => {});

        props.logLeadAction("Zmiana statusu sprawy: " + props.user, el);

        var body = {
          id: el,
        };

        await fetch("https://apidevkppp.ftpeople.pl/archivizeLead", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {})
          .catch((error) => {});
      });

      MySwal.fire({
        icon: "success",
        title: "Zamknięto",
        text: "kontakty",
      }).then(async (result) => {
        getData();
      });
    }
  };

  const leadsData = (
    <>
      <p className="lCounter">Liczba kontaktów: {leads.length}</p>
      <table style={{ marginTop: "0vh" }} className="clients_table">
        <tr key={0}>
          {props.user.adminSprzedaz === "1" ? <th>Do zamknięcia</th> : ""}
          <th>ID</th>
          <th>Nazwa</th>
          <th>Pracownik</th>
          <th>Numer Telefonu</th>
          <th>Adres e-mail</th>
          <th>Bank</th>
          <th>Źródło</th>
          {props.user.salesSuperAdmin === "1" ? <th>Źródło - oryginał</th> : ""}
          <th>Status</th>
          <th>Data kolejnego zadania</th>
          <th>Dokumenty</th>
          <th>Rodzaj</th>
        </tr>
        {leads.slice(getNValue(), getValue()).map((el, index) => (
          <>
            <tr
              style={el.arch === "1" ? { backgroundColor: "yellow" } : {}}
              id={""}
              key={el.id}
            >
              {props.user.adminSprzedaz === "1" ? (
                <td>
                  <input
                    id="checkCal3"
                    type="checkbox"
                    style={{ width: "15px" }}
                    value={el.id}
                    onChange={chooseLead}
                  />
                </td>
              ) : (
                ""
              )}
              <td
                value={el.id}
                onClick={handleRowClick}
                style={
                  props.user.adminSprzedaz === "1" && el.duplicate === "1"
                    ? { backgroundColor: "orange", color: "white" }
                    : {}
                }
              >
                {el.id}
              </td>
              <td
                style={{
                  textAlign: "left",
                  paddingLeft: "5px",
                  fontWeight: "600",
                  maxWidth: "15%",
                  wordBreak: "break-word",
                }}
                value={el.id}
                onClick={handleRowClick}
              >
                {el.name}{" "}
              </td>
              <td
                style={{
                  textAlign: "center",
                  paddingLeft: "5px",
                  fontWeight: "400",
                  maxWidth: "13%",
                  width: "10%",
                  wordBreak: "break-word",
                }}
                value={el.id}
              >
                {el.owner === "" || el.owner === null
                  ? "brak danych"
                  : getInitials(el.owner)}{" "}
                {props.user.adminSprzedaz === "1" ? (
                  <>
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value={el.id}
                      onClick={handleShowEditLeadOwner}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </>
                ) : (
                  ""
                )}
              </td>
              <td value={el.id} onClick={handleRowClick}>
                {el.phone}
              </td>
              <td value={el.id} onClick={handleRowClick}>
                {el.mail}
              </td>
              <td
                style={{ width: "15%" }}
                value={el.id}
                onClick={handleRowClick}
              >
                {el.bank === "" || el.bank === null || el.bank === undefined
                  ? "brak danych"
                  : el.bank}
              </td>
              <td value={el.id} onClick={handleRowClick}>
                {el.source}
              </td>
              {props.user.salesSuperAdmin === "1" ? (
                <td value={el.id} onClick={handleRowClick}>
                  {el.realSource}
                </td>
              ) : (
                ""
              )}
              <td value={el.id} onClick={handleRowClick}>
                {el.status}
              </td>
              <td value={el.id} onClick={handleRowClick}>
                {el.lastTask}
              </td>
              <td value={el.id} onClick={handleRowClick}>
                {+el.docs > 0 ? "TAK" : "NIE"}
              </td>
              <td value={el.id} onClick={handleRowClick}>
                {el.type}
              </td>
            </tr>
          </>
        ))}
      </table>
      <div
        style={{
          display: "flex",
          justifyContent: "right",
          width: "100%",
          alignItems: "flex-end",
          marginTop: "5vh",
        }}
        className="searchBoxP"
      >
        <button
          style={{
            backgroundColor: "#00bdce",
            border: "none",
            color: "white",
            fontWeight: "600",
            borderRadius: "15px",
          }}
          id="clientsFilterButton"
          className="paymentMenuButton"
          onClick={scrollTop}
        >
          Przejdź na górę listy
        </button>
      </div>
    </>
  );

  const closeAllHovering = (e) => {
    if (
      e.target.id !== "user" &&
      e.target.id !== "source" &&
      e.target.id !== "status" &&
      e.target.id !== "type" &&
      e.target.id !== "bank"
    ) {
      setIsHoveringUser(false);
      setIsHoveringSource(false);
      setIsHoveringStatus(false);
      setIsHoveringType(false);
      setIsHoveringBank(false);
    }
  };

  const handleFilterClear = () => {
    setPage(1);
    setSelectedOptionsSource([]);
    setSelectedOptionsStatus([]);
    setSelectedOptionsType([]);
    setSelectedOptionsUser([]);
    setSourceSearch("");
    setStatusSearch("");
    setTypeSearch("");
    setUserSearch("");
    setWideSearch("");
    setIdSearch("");
    setFilterDuplicate(false);
    setFilterDocuments(false);
    setAddDateFilter(false);
    setDateAddLeadFrom("");
    setDateAddLeadTo("");
    setAssDateFilter(false);
    setDateAssLeadFrom("");
    setDateAssLeadTo("");
    setLeads(leadsClear.filter((el) => el.archive === "0"));
    setCSDateFilter(false);
    setDateCSLeadFrom("");
    setDateCSLeadTo("");
    setFilterDuplicate(false);
    setFilterDocuments(false);
    setFilterNotAssigned(false);
  };

  const closeEditLeadOwner = () => {
    setShowEditLeadOwner(false);
    getData();
  };

  const handleDateAddLeadFrom = (e) => {
    if (new Date(e.target.value) > new Date(dateAddLeadTo)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może być większa niż "Data do"',
      });
      return;
    }
    setDateAddLeadFrom(e.target.value);
  };

  const handleDateAddLeadTo = (e) => {
    if (new Date(e.target.value) < new Date(dateAddLeadFrom)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może byćmniejsza niż "Data od"',
      });
      return;
    }
    setDateAddLeadTo(e.target.value);
  };

  const handleAddDateFilter = (e) => {
    setAddDateFilter(true);
    handleFilterChange("addDate", true);
  };

  const handleDateAssLeadFrom = (e) => {
    if (new Date(e.target.value) > new Date(dateAssLeadTo)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może być większa niż "Data do"',
      });
      return;
    }
    setDateAssLeadFrom(e.target.value);
  };

  const handleDateAssLeadTo = (e) => {
    if (new Date(e.target.value) < new Date(dateAssLeadFrom)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może byćmniejsza niż "Data od"',
      });
      return;
    }
    setDateAssLeadTo(e.target.value);
  };

  const handleAssDateFilter = (e) => {
    setAssDateFilter(true);
    handleFilterChange("assDate", true);
  };

  const handleDateCSLeadFrom = (e) => {
    if (new Date(e.target.value) > new Date(dateCSLeadTo)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może być większa niż "Data do"',
      });
      return;
    }
    setDateCSLeadFrom(e.target.value);
  };

  const handleDateCSLeadTo = (e) => {
    if (new Date(e.target.value) < new Date(dateCSLeadFrom)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może byćmniejsza niż "Data od"',
      });
      return;
    }
    setDateCSLeadTo(e.target.value);
  };

  const handleCSDateFilter = (e) => {
    setCSDateFilter(true);
    handleFilterChange("csDate", true);
  };

  const checkDuplicateFilter = () => {
    setFilterDuplicate(!filterDuplicate);
    handleFilterChange("duplicate", !filterDuplicate);
  };

  const checkNotAssignedFilter = () => {
    setFilterNotAssigned(!filterNotAssigned);
    handleFilterChange("notassigned", !filterNotAssigned);
  };

  const checkDocumentsFilter = () => {
    setFilterDocuments(!filterDocuments);
    handleFilterChange("documents", !filterDocuments);
  };

  const desktopFilters = (
    <>
      <div className="paymentMenuContainer" style={{ marginTop: "2vh" }}>
        {props.user.role === "consultantTele" ||
        props.user.role === "consultantTeleSKD" ? (
          ""
        ) : (
          <>
            <button
              style={{
                backgroundColor: "#876487",
                border: "none",
                color: "white",
                fontWeight: "600",
                borderRadius: "15px",
              }}
              className="paymentMenuButton"
              onClick={handleShowStatistics}
            >
              Statystyki
            </button>
          </>
        )}
        <button
          style={{
            backgroundColor: "orange",
            border: "none",
            color: "white",
            fontWeight: "600",
            borderRadius: "15px",
          }}
          className="paymentMenuButton"
          onClick={getData}
        >
          Odśwież
        </button>
        {props.user.adminSprzedaz === "1" ? (
          <>
            <button
              style={{
                backgroundColor: "green",
                border: "none",
                color: "white",
                fontWeight: "600",
                borderRadius: "15px",
              }}
              className="paymentMenuButton"
              onClick={handleShowAddLeadOwner}
            >
              Przypisz prawnika
            </button>
          </>
        ) : (
          ""
        )}
      </div>
      <div
        style={{ marginTop: "5vh", marginBottom: "0vh" }}
        className="filtersClients"
      >
        <div
          style={{ marginBottom: "0vh", width: "18%" }}
          className="searchBoxP"
        >
          <label id="clientsFilterLabel">ID</label>
          <input
            type="text"
            id="clientsFilterInput"
            name="name"
            value={idSearch}
            onChange={handleIdSearchChange}
          />
        </div>
        <div
          style={{ marginBottom: "0vh", width: "18%" }}
          className="searchBoxP"
        >
          <label id="clientsFilterLabel">Nazwa | e-mail | numer telefonu</label>
          <input
            type="text"
            id="clientsFilterInput"
            name="name"
            value={wideSearch}
            onChange={handleWideSearchChange}
          />
        </div>
        {props.user.adminSprzedaz === "1" ? (
          <>
            <div
              style={{ marginBottom: "0vh", width: "18%" }}
              className="searchBoxP"
            >
              <label id="clientsFilterLabel">Pracownik</label>
              <div className="multiContainer">
                <MultiSelectNew
                  options={getUserOptions()}
                  value={userSearch}
                  onChange={handleUserSearchChange}
                  selectedOptions={selectedOptionsUser}
                  setSelectedOptions={setSelectedOptionsUser}
                  isHovering={isHoveringUser}
                  setIsHovering={setIsHoveringUser}
                  id={"user"}
                  closeAllHovering={closeAllHovering}
                />
              </div>
            </div>
          </>
        ) : (
          ""
        )}
        {props.user.role === "consultantTele" ? (
          <>
            <div
              style={{ marginBottom: "0vh", width: "18%" }}
              className="searchBoxP"
            >
              <label id="clientsFilterLabel">Pracownik</label>
              <div className="multiContainer">
                <MultiSelectNew
                  options={getUserOptions()}
                  value={userSearch}
                  onChange={handleUserSearchChange}
                  selectedOptions={selectedOptionsUser}
                  setSelectedOptions={setSelectedOptionsUser}
                  isHovering={isHoveringUser}
                  setIsHovering={setIsHoveringUser}
                  id={"user"}
                  closeAllHovering={closeAllHovering}
                />
              </div>
            </div>
          </>
        ) : (
          ""
        )}

        {props.user.role === "consultantTele" ||
        props.user.role === "consultantTeleSKD" ? (
          ""
        ) : (
          <>
            <div
              style={{ marginBottom: "0vh", width: "18%" }}
              className="searchBoxP"
            >
              <label id="clientsFilterLabel">Status</label>
              <div className="multiContainer">
                <MultiSelectNew
                  options={getStatusOptions()}
                  value={statusSearch}
                  onChange={handleStatusSearchChange}
                  selectedOptions={selectedOptionsStatus}
                  setSelectedOptions={setSelectedOptionsStatus}
                  isHovering={isHoveringStatus}
                  setIsHovering={setIsHoveringStatus}
                  id={"status"}
                  closeAllHovering={closeAllHovering}
                />
              </div>
            </div>
          </>
        )}

        <div style={{ width: "100%" }}></div>
        <div
          style={{ marginBottom: "0vh", width: "18%" }}
          className="searchBoxP"
        >
          <label id="clientsFilterLabel">Źródło pozyskania</label>
          <div className="multiContainer">
            <MultiSelectNew
              options={getSourceOptions()}
              value={sourceSearch}
              onChange={handleSourceSearchChange}
              selectedOptions={selectedOptionsSource}
              setSelectedOptions={setSelectedOptionsSource}
              isHovering={isHoveringSource}
              setIsHovering={setIsHoveringSource}
              id={"source"}
              closeAllHovering={closeAllHovering}
            />
          </div>
        </div>

        {props.user.role === "consultantTele" ||
        props.user.role === "consultantTeleSKD" ? (
          ""
        ) : (
          <>
            <div
              style={{ marginBottom: "0vh", width: "18%" }}
              className="searchBoxP"
            >
              <label id="clientsFilterLabel">Rodzaj</label>
              <div className="multiContainer">
                <MultiSelectNew
                  options={getTypeOptions()}
                  value={typeSearch}
                  onChange={handleTypeSearchChange}
                  selectedOptions={selectedOptionsType}
                  setSelectedOptions={setSelectedOptionsType}
                  isHovering={isHoveringType}
                  setIsHovering={setIsHoveringType}
                  id={"type"}
                  closeAllHovering={closeAllHovering}
                />
              </div>
            </div>
          </>
        )}
        <div
          style={{ marginBottom: "0vh", width: "18%" }}
          className="searchBoxP"
        >
          <label id="clientsFilterLabel">Bank</label>
          <div className="multiContainer">
            <MultiSelectNew
              options={getBanksOptions()}
              value={bankSearch}
              onChange={handleBankSearchChange}
              selectedOptions={selectedOptionsBank}
              setSelectedOptions={setSelectedOptionsBank}
              isHovering={isHoveringBank}
              setIsHovering={setIsHoveringBank}
              id={"bank"}
              closeAllHovering={closeAllHovering}
            />
          </div>
        </div>
        {props.user.adminSprzedaz === "1" ? (
          <>
            <div
              style={{
                marginBottom: "0vh",
                width: "15%",
                display: "flex",
                alignItems: "center",
              }}
              className="searchBoxP"
            >
              <div
                className="multiContainer"
                style={{ paddingTop: "2vh", width: "100%" }}
              >
                <div
                  style={{
                    height: "2.5vh",
                    fontWeight: "300",
                    fontSize: "0.8vw",
                    width: "100%",
                  }}
                  className="checkBox"
                >
                  <input
                    style={{ width: "10%", height: "2vh" }}
                    id="checkCal2"
                    type="checkbox"
                    checked={filterNotAssigned}
                    onChange={checkNotAssignedFilter}
                  />
                  Kontakty nieprzypsane
                </div>
                <div
                  style={{
                    height: "2.5vh",
                    fontWeight: "300",
                    fontSize: "0.8vw",
                    width: "100%",
                  }}
                  className="checkBox"
                >
                  <input
                    style={{ width: "10%", height: "2vh" }}
                    id="checkCal2"
                    type="checkbox"
                    checked={filterDuplicate}
                    onChange={checkDuplicateFilter}
                  />
                  Kontakty zduplikowane
                </div>
                <div
                  style={{
                    height: "2.5vh",
                    fontWeight: "300",
                    fontSize: "0.8vw",
                    width: "100%",
                  }}
                  className="checkBox"
                >
                  <input
                    style={{ width: "10%", height: "2vh" }}
                    id="checkCal2"
                    type="checkbox"
                    checked={filterDocuments}
                    onChange={checkDocumentsFilter}
                  />
                  Dokumenty umowy kredytu
                </div>
              </div>
            </div>
          </>
        ) : (
          ""
        )}

        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            marginBottom: "0vh",
            width: "24%",
            gap: "20px",
          }}
          className="searchBoxP"
        >
          <button
            style={{
              backgroundColor: "#00bdce",
              border: "none",
              color: "white",
              fontWeight: "600",
              borderRadius: "15px",
            }}
            id="clientsFilterButton"
            className="paymentMenuButton"
            onClick={handleFilterClear}
          >
            Wyczyść filtr
          </button>
          <button
            style={{
              backgroundColor: "#00bdce",
              border: "none",
              color: "white",
              fontWeight: "600",
              borderRadius: "15px",
            }}
            id="clientsFilterButton"
            className="paymentMenuButton"
            onClick={scrollBottom}
          >
            Przejdź na dół listy
          </button>
        </div>
      </div>
      <div
        style={{
          justifyContent: "right",
          marginBottom: "2vh",
          marginTop: "3vh",
        }}
        className="filtersClients"
      >
        <div
          style={{ marginBottom: "0vh", width: "18%" }}
          className="searchBoxP"
        >
          <label id="clientsFilterLabel">Sortuj według</label>
          <select
            type="text"
            id="clientsFilterInput"
            name="name"
            value={sort}
            onChange={handleSortChange}
          >
            {sort === "" ? (
              <option key={10} value="sortX">
                Wybierz...
              </option>
            ) : (
              ""
            )}
            <option key={0} value="sort1">
              Data wprowadzenia kontaktu - od najstarszej
            </option>
            <option key={1} value="sort2">
              Data wprowadzenia kontaktu - od najmłodszej
            </option>
            <option key={2} value="sort3">
              Według identyfikatora - rosnąco
            </option>
            <option key={3} value="sort4">
              Według identyfikatora - malejąco
            </option>
            <option key={4} value="sort5">
              Data ostatniego kontaktu - od najstarszej
            </option>
            <option key={5} value="sort6">
              Data ostatniego kontaktu - od najmłodszej
            </option>
          </select>
        </div>
      </div>
      <div style={{ display: "flex" }}>
        <div
          style={{
            marginTop: "-10vh",
            marginBottom: "5vh",
            width: "30%",
          }}
        >
          <label style={{ fontSize: ".8vw", fontWeight: "600" }}>
            Data dodania kontaktu
          </label>
          <div style={{ marginTop: "5px" }} className="inputBox">
            <div
              style={{ width: "45%", minWidth: "auto" }}
              className="inputCol_2"
            >
              <label style={{ fontSize: ".8vw" }}>Od</label>
              <input
                style={{ height: "3vh" }}
                type="date"
                id="name"
                name="name"
                value={dateAddLeadFrom}
                onChange={handleDateAddLeadFrom}
              />
            </div>
            <div
              style={{ width: "45%", minWidth: "auto" }}
              className="inputCol_2"
            >
              <label style={{ fontSize: ".8vw" }}>Do</label>
              <input
                style={{ height: "3vh" }}
                type="date"
                id="name"
                name="name"
                value={dateAddLeadTo}
                onChange={handleDateAddLeadTo}
              />
            </div>
          </div>
          <div style={{ marginTop: "2vh" }}>
            <button
              style={{
                backgroundColor: "#00bdce",
                border: "none",
                color: "white",
                fontWeight: "600",
                borderRadius: "15px",
              }}
              id="clientsFilterButton"
              className="paymentMenuButton"
              onClick={handleAddDateFilter}
            >
              Pokaż
            </button>
          </div>
        </div>
        {props.user.role === "consultantTele" ||
        props.user.role === "consultantTeleSKD" ? (
          ""
        ) : (
          <>
            <div
              style={{
                marginTop: "-10vh",
                marginBottom: "5vh",
                width: "30%",
              }}
            >
              <label style={{ fontSize: ".8vw", fontWeight: "600" }}>
                Data przypisania kontaktu
              </label>
              <div style={{ marginTop: "5px" }} className="inputBox">
                <div
                  style={{ width: "45%", minWidth: "auto" }}
                  className="inputCol_2"
                >
                  <label style={{ fontSize: ".8vw" }}>Od</label>
                  <input
                    style={{ height: "3vh" }}
                    type="date"
                    id="name"
                    name="name"
                    value={dateAssLeadFrom}
                    onChange={handleDateAssLeadFrom}
                  />
                </div>
                <div
                  style={{ width: "45%", minWidth: "auto" }}
                  className="inputCol_2"
                >
                  <label style={{ fontSize: ".8vw" }}>Do</label>
                  <input
                    style={{ height: "3vh" }}
                    type="date"
                    id="name"
                    name="name"
                    value={dateAssLeadTo}
                    onChange={handleDateAssLeadTo}
                  />
                </div>
              </div>
              <div style={{ marginTop: "2vh" }}>
                <button
                  style={{
                    backgroundColor: "#00bdce",
                    border: "none",
                    color: "white",
                    fontWeight: "600",
                    borderRadius: "15px",
                  }}
                  id="clientsFilterButton"
                  className="paymentMenuButton"
                  onClick={handleAssDateFilter}
                >
                  Pokaż
                </button>
              </div>
            </div>
          </>
        )}
      </div>
      {props.user.role === "consultantTele" ||
      props.user.role === "consultantTeleSKD" ? (
        ""
      ) : (
        <>
          <div style={{ display: "flex", marginTop: "8vh" }}>
            <div
              style={{
                marginTop: "-10vh",
                marginBottom: "5vh",
                width: "30%",
              }}
            >
              <label style={{ fontSize: ".8vw", fontWeight: "600" }}>
                Data zmiany statusu
              </label>
              <div style={{ marginTop: "5px" }} className="inputBox">
                <div
                  style={{ width: "45%", minWidth: "auto" }}
                  className="inputCol_2"
                >
                  <label style={{ fontSize: ".8vw" }}>Od</label>
                  <input
                    style={{ height: "3vh" }}
                    type="date"
                    id="name"
                    name="name"
                    value={dateCSLeadFrom}
                    onChange={handleDateCSLeadFrom}
                  />
                </div>
                <div
                  style={{ width: "45%", minWidth: "auto" }}
                  className="inputCol_2"
                >
                  <label style={{ fontSize: ".8vw" }}>Do</label>
                  <input
                    style={{ height: "3vh" }}
                    type="date"
                    id="name"
                    name="name"
                    value={dateCSLeadTo}
                    onChange={handleDateCSLeadTo}
                  />
                </div>
              </div>
              <div style={{ marginTop: "2vh" }}>
                <button
                  style={{
                    backgroundColor: "#00bdce",
                    border: "none",
                    color: "white",
                    fontWeight: "600",
                    borderRadius: "15px",
                  }}
                  id="clientsFilterButton"
                  className="paymentMenuButton"
                  onClick={handleCSDateFilter}
                >
                  Pokaż
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          marginBottom: "0vh",
          width: "23.4%",
          gap: "20px",
          marginTop: "20px",
        }}
        className="searchBoxP"
      >
        <button
          style={{
            backgroundColor: "#00bdce",
            border: "none",
            color: "white",
            fontWeight: "600",
            borderRadius: "15px",
          }}
          id="clientsFilterButton"
          className="paymentMenuButton"
          onClick={exportToExcel}
        >
          EXPORT
        </button>
        {props.user.adminSprzedaz === "1" && arrToClose.length > 0 ? (
          <button
            style={{
              backgroundColor: "#00bdce",
              border: "none",
              color: "white",
              fontWeight: "600",
              borderRadius: "15px",
            }}
            id="clientsFilterButton"
            className="paymentMenuButton"
            onClick={closeManyLeads}
          >
            ZAMKNIJ WYBRANE KONTAKTY
          </button>
        ) : (
          ""
        )}
      </div>
    </>
  );

  const handleExpandMobileChange = () => {
    setExpandMobileFilters(!expandMobileFilters);
  };

  const mobileFilters = (
    <>
      <div className="paymentMenuContainer" style={{ marginTop: "2vh" }}>
        {props.user.role === "consultantTele" ||
        props.user.role === "consultantTeleSKD" ? (
          ""
        ) : (
          <>
            <button
              style={{
                backgroundColor: "#876487",
                border: "none",
                color: "white",
                fontWeight: "600",
                borderRadius: "15px",
              }}
              className="paymentMenuButton"
              onClick={handleShowStatistics}
            >
              Statystyki
            </button>
          </>
        )}
        <button
          style={{
            backgroundColor: "orange",
            border: "none",
            color: "white",
            fontWeight: "600",
            borderRadius: "15px",
          }}
          className="paymentMenuButton"
          onClick={getData}
        >
          Odśwież
        </button>
        {props.user.adminSprzedaz === "1" ? (
          <>
            <button
              style={{
                backgroundColor: "green",
                border: "none",
                color: "white",
                fontWeight: "600",
                borderRadius: "15px",
              }}
              className="paymentMenuButton"
              onClick={handleShowAddLeadOwner}
            >
              Przypisz prawnika
            </button>
          </>
        ) : (
          ""
        )}
      </div>
      <div
        style={
          expandMobileFilters
            ? { display: "flex", width: "100%", padding: "3vh 0" }
            : { display: "flex", width: "100%", padding: "3vh 0" }
        }
      >
        <div style={{ width: "100%" }}>
          <button
            className="calendarUserButton"
            style={{ width: "100%", justifyContent: "center" }}
            value={props.user.name}
            onClick={handleExpandMobileChange}
          >
            {!expandMobileFilters ? "ROZWIŃ FILTRY" : "ZWIŃ FILTRY"}
          </button>
        </div>
      </div>
      {expandMobileFilters ? (
        <>
          <div style={{ marginBottom: "0vh" }} className="filtersClients">
            <div style={{ marginBottom: "0vh" }} className="searchBoxP">
              <label id="clientsFilterLabel">ID</label>
              <input
                type="text"
                id="clientsFilterInput"
                name="name"
                value={idSearch}
                onChange={handleIdSearchChange}
              />
            </div>
            <div style={{ marginBottom: "0vh" }} className="searchBoxP">
              <label id="clientsFilterLabel">
                Nazwa | e-mail | numer telefonu
              </label>
              <input
                type="text"
                id="clientsFilterInput"
                name="name"
                value={wideSearch}
                onChange={handleWideSearchChange}
              />
            </div>
            {props.user.adminSprzedaz === "1" ? (
              <>
                <div style={{ marginBottom: "0vh" }} className="searchBoxP">
                  <label id="clientsFilterLabel">Pracownik</label>
                  <div className="multiContainer">
                    <MultiSelectNew
                      options={getUserOptions()}
                      value={userSearch}
                      onChange={handleUserSearchChange}
                      selectedOptions={selectedOptionsUser}
                      setSelectedOptions={setSelectedOptionsUser}
                      isHovering={isHoveringUser}
                      setIsHovering={setIsHoveringUser}
                      id={"user"}
                      closeAllHovering={closeAllHovering}
                    />
                  </div>
                </div>
              </>
            ) : (
              ""
            )}

            {props.user.role === "consultantTele" &&
            props.user.role === "consultantTeleSKD" ? (
              ""
            ) : (
              <>
                <div style={{ marginBottom: "0vh" }} className="searchBoxP">
                  <label id="clientsFilterLabel">Status</label>
                  <div className="multiContainer">
                    <MultiSelectNew
                      options={getStatusOptions()}
                      value={statusSearch}
                      onChange={handleStatusSearchChange}
                      selectedOptions={selectedOptionsStatus}
                      setSelectedOptions={setSelectedOptionsStatus}
                      isHovering={isHoveringStatus}
                      setIsHovering={setIsHoveringStatus}
                      id={"status"}
                      closeAllHovering={closeAllHovering}
                    />
                  </div>
                </div>
              </>
            )}

            <div style={{ width: "100%" }}></div>
            <div style={{ marginBottom: "0vh" }} className="searchBoxP">
              <label id="clientsFilterLabel">Źródło pozyskania</label>
              <div className="multiContainer">
                <MultiSelectNew
                  options={getSourceOptions()}
                  value={sourceSearch}
                  onChange={handleSourceSearchChange}
                  selectedOptions={selectedOptionsSource}
                  setSelectedOptions={setSelectedOptionsSource}
                  isHovering={isHoveringSource}
                  setIsHovering={setIsHoveringSource}
                  id={"source"}
                  closeAllHovering={closeAllHovering}
                />
              </div>
            </div>

            {props.user.role === "consultantTele" &&
            props.user.role === "consultantTeleSKD" ? (
              ""
            ) : (
              <>
                <div style={{ marginBottom: "0vh" }} className="searchBoxP">
                  <label id="clientsFilterLabel">Rodzaj</label>
                  <div className="multiContainer">
                    <MultiSelectNew
                      options={getTypeOptions()}
                      value={typeSearch}
                      onChange={handleTypeSearchChange}
                      selectedOptions={selectedOptionsType}
                      setSelectedOptions={setSelectedOptionsType}
                      isHovering={isHoveringType}
                      setIsHovering={setIsHoveringType}
                      id={"type"}
                      closeAllHovering={closeAllHovering}
                    />
                  </div>
                </div>
              </>
            )}
            <div style={{ marginBottom: "0vh" }} className="searchBoxP">
              <label id="clientsFilterLabel">Bank</label>
              <div className="multiContainer">
                <MultiSelectNew
                  options={getBanksOptions()}
                  value={bankSearch}
                  onChange={handleBankSearchChange}
                  selectedOptions={selectedOptionsBank}
                  setSelectedOptions={setSelectedOptionsBank}
                  isHovering={isHoveringBank}
                  setIsHovering={setIsHoveringBank}
                  id={"bank"}
                  closeAllHovering={closeAllHovering}
                />
              </div>
            </div>
            {props.user.adminSprzedaz === "1" ? (
              <>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                  }}
                  className="searchBoxP"
                >
                  <div
                    className="multiContainer"
                    style={{ paddingTop: "2vh", width: "100%" }}
                  >
                    <div
                      style={{
                        height: "2.5vh",
                        fontWeight: "300",
                        fontSize: "0.8vw",
                        width: "100%",
                      }}
                      className="checkBox"
                    >
                      <input
                        style={{ width: "10%", height: "2vh" }}
                        id="checkCal2"
                        type="checkbox"
                        checked={filterNotAssigned}
                        onChange={checkNotAssignedFilter}
                      />
                      Kontakty nieprzypsane
                    </div>
                    <div
                      style={{
                        height: "2.5vh",
                        fontWeight: "300",
                        fontSize: "0.8vw",
                        width: "100%",
                      }}
                      className="checkBox"
                    >
                      <input
                        style={{ width: "10%", height: "2vh" }}
                        id="checkCal2"
                        type="checkbox"
                        checked={filterDuplicate}
                        onChange={checkDuplicateFilter}
                      />
                      Kontakty zduplikowane
                    </div>
                    <div
                      style={{
                        height: "2.5vh",
                        fontWeight: "300",
                        fontSize: "0.8vw",
                        width: "100%",
                      }}
                      className="checkBox"
                    >
                      <input
                        style={{ width: "10%", height: "2vh" }}
                        id="checkCal2"
                        type="checkbox"
                        checked={filterDocuments}
                        onChange={checkDocumentsFilter}
                      />
                      Dokumenty umowy kredytu
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
          </div>

          <div style={{ display: "block" }}>
            <div
              style={{
                marginBottom: "1vh",
                width: "100%",
              }}
            >
              <label style={{ fontSize: ".8vw", fontWeight: "600" }}>
                Data dodania kontaktu
              </label>
              <div style={{ marginTop: "5px" }} className="inputBox">
                <div
                  style={{ width: "45%", minWidth: "auto" }}
                  className="inputCol_2"
                >
                  <label style={{ fontSize: ".8vw" }}>Od</label>
                  <input
                    style={{ height: "3vh" }}
                    type="date"
                    id="name"
                    name="name"
                    value={dateAddLeadFrom}
                    onChange={handleDateAddLeadFrom}
                  />
                </div>
                <div
                  style={{ width: "45%", minWidth: "auto" }}
                  className="inputCol_2"
                >
                  <label style={{ fontSize: ".8vw" }}>Do</label>
                  <input
                    style={{ height: "3vh" }}
                    type="date"
                    id="name"
                    name="name"
                    value={dateAddLeadTo}
                    onChange={handleDateAddLeadTo}
                  />
                </div>
              </div>
              <div style={{ marginTop: "2vh" }}>
                <button
                  style={{
                    backgroundColor: "#00bdce",
                    border: "none",
                    color: "white",
                    fontWeight: "600",
                    borderRadius: "15px",
                  }}
                  id="clientsFilterButton"
                  className="paymentMenuButton"
                  onClick={handleAddDateFilter}
                >
                  Pokaż
                </button>
              </div>
            </div>
            {props.user.role === "consultantTele" ||
            props.user.role === "consultantTeleSKD" ? (
              ""
            ) : (
              <>
                <div
                  style={{
                    marginBottom: "1vh",
                    width: "100%",
                  }}
                >
                  <label style={{ fontSize: ".8vw", fontWeight: "600" }}>
                    Data przypisania kontaktu
                  </label>
                  <div style={{ marginTop: "5px" }} className="inputBox">
                    <div
                      style={{ width: "45%", minWidth: "auto" }}
                      className="inputCol_2"
                    >
                      <label style={{ fontSize: ".8vw" }}>Od</label>
                      <input
                        style={{ height: "3vh" }}
                        type="date"
                        id="name"
                        name="name"
                        value={dateAssLeadFrom}
                        onChange={handleDateAssLeadFrom}
                      />
                    </div>
                    <div
                      style={{ width: "45%", minWidth: "auto" }}
                      className="inputCol_2"
                    >
                      <label style={{ fontSize: ".8vw" }}>Do</label>
                      <input
                        style={{ height: "3vh" }}
                        type="date"
                        id="name"
                        name="name"
                        value={dateAssLeadTo}
                        onChange={handleDateAssLeadTo}
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: "2vh" }}>
                    <button
                      style={{
                        backgroundColor: "#00bdce",
                        border: "none",
                        color: "white",
                        fontWeight: "600",
                        borderRadius: "15px",
                      }}
                      id="clientsFilterButton"
                      className="paymentMenuButton"
                      onClick={handleAssDateFilter}
                    >
                      Pokaż
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          {props.user.role === "consultantTele" ||
          props.user.role === "consultantTeleSKD" ? (
            ""
          ) : (
            <>
              <div style={{ display: "block" }}>
                <div
                  style={{
                    marginBottom: "1vh",
                    width: "100%",
                  }}
                >
                  <label style={{ fontSize: ".8vw", fontWeight: "600" }}>
                    Data zmiany statusu
                  </label>
                  <div style={{ marginTop: "5px" }} className="inputBox">
                    <div
                      style={{ width: "45%", minWidth: "auto" }}
                      className="inputCol_2"
                    >
                      <label style={{ fontSize: ".8vw" }}>Od</label>
                      <input
                        style={{ height: "3vh" }}
                        type="date"
                        id="name"
                        name="name"
                        value={dateCSLeadFrom}
                        onChange={handleDateCSLeadFrom}
                      />
                    </div>
                    <div
                      style={{ width: "45%", minWidth: "auto" }}
                      className="inputCol_2"
                    >
                      <label style={{ fontSize: ".8vw" }}>Do</label>
                      <input
                        style={{ height: "3vh" }}
                        type="date"
                        id="name"
                        name="name"
                        value={dateCSLeadTo}
                        onChange={handleDateCSLeadTo}
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: "2vh" }}>
                    <button
                      style={{
                        backgroundColor: "#00bdce",
                        border: "none",
                        color: "white",
                        fontWeight: "600",
                        borderRadius: "15px",
                      }}
                      id="clientsFilterButton"
                      className="paymentMenuButton"
                      onClick={handleCSDateFilter}
                    >
                      Pokaż
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}
          <div
            style={{
              justifyContent: "right",
              marginBottom: "2vh",
              marginTop: "3vh",
            }}
            className="filtersClients"
          >
            <div
              style={{ marginBottom: "0vh", width: "100%" }}
              className="searchBoxP"
            >
              <label id="clientsFilterLabel">Sortuj według</label>
              <select
                type="text"
                id="clientsFilterInput"
                name="name"
                value={sort}
                onChange={handleSortChange}
              >
                {sort === "" ? (
                  <option key={10} value="sortX">
                    Wybierz...
                  </option>
                ) : (
                  ""
                )}
                <option key={0} value="sort1">
                  Data wprowadzenia kontaktu - od najstarszej
                </option>
                <option key={1} value="sort2">
                  Data wprowadzenia kontaktu - od najmłodszej
                </option>
                <option key={2} value="sort3">
                  Według identyfikatora - rosnąco
                </option>
                <option key={3} value="sort4">
                  Według identyfikatora - malejąco
                </option>
                <option key={4} value="sort5">
                  Data ostatniego kontaktu - od najstarszej
                </option>
                <option key={5} value="sort6">
                  Data ostatniego kontaktu - od najmłodszej
                </option>
              </select>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              marginBottom: "1vh",
              width: "100%",
              gap: "20px",
              marginTop: "20px",
            }}
            className="searchBoxP"
          >
            <button
              style={{
                backgroundColor: "#00bdce",
                border: "none",
                color: "white",
                fontWeight: "600",
                borderRadius: "15px",
                width: "100%",
              }}
              id="clientsFilterButton"
              className="paymentMenuButton"
              onClick={exportToExcel}
            >
              EXPORT
            </button>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              marginBottom: "1vh",
              width: "100%",
              gap: "20px",
            }}
            className="searchBoxP"
          >
            <button
              style={{
                backgroundColor: "#00bdce",
                border: "none",
                color: "white",
                fontWeight: "600",
                borderRadius: "15px",
                width: "100%",
              }}
              id="clientsFilterButton"
              className="paymentMenuButton"
              onClick={handleFilterClear}
            >
              Wyczyść filtr
            </button>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              marginBottom: "3vh",
              width: "100%",
              gap: "20px",
            }}
            className="searchBoxP"
          >
            <button
              style={{
                backgroundColor: "#00bdce",
                border: "none",
                color: "white",
                fontWeight: "600",
                borderRadius: "15px",
                width: "100%",
              }}
              id="clientsFilterButton"
              className="paymentMenuButton"
              onClick={scrollBottom}
            >
              Przejdź na dół listy
            </button>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );

  return (
    <>
      <div
        id="reportC"
        className="mainContainerClients"
        onClick={closeAllHovering}
      >
        {loading ? (
          <>
            <Loading />
          </>
        ) : (
          <>
            {showAddLeadOwner ? (
              <>
                <EditLeadOwnerMain
                  close={handleCloseAddLeadOwner}
                  user={props.user.name}
                  logClientAction={props.logLeadAction}
                />
              </>
            ) : (
              ""
            )}
            {showLeadPopUp ? (
              <>
                <LeadPopUp
                  close={closeLeadPopUp}
                  lead={leadC}
                  logLeadAction={props.logLeadAction}
                  user={props.user}
                  generateAnalysis={props.generateAnalysis}
                />
              </>
            ) : showStatistics ? (
              <StatisticsLeads
                close={closeStatistics}
                leads={leads}
                user={props.user}
              />
            ) : (
              <>
                <div className="desktopFilters">{desktopFilters}</div>
                <div className="mobileFilters">{mobileFilters}</div>

                <div id="testScroll" className="contentBoxPayments">
                  <div className="desktopFilters">{leadsData}</div>
                  <div className="mobileFilters">{leadsDataMobile}</div>
                </div>
                <div className="desktopFilters">
                  <div
                    style={{
                      marginTop: "2vh",
                      display: "flex",
                      gap: "15px",
                    }}
                  >
                    <span style={{ width: "130px" }}>
                      STR. {page}/{Math.ceil(leads.length / +perPage)}
                    </span>
                    <button
                      className="loginButtonLogin"
                      onClick={handleSubPage}
                      style={{
                        margin: "0",
                        backgroundColor: "rgb(0, 189, 206)",
                        borderColor: "orange",
                        fontSize: ".6vw",
                        width: "20px",
                        height: "2vh",
                        color: "white",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {"<"}
                    </button>
                    <button
                      className="loginButtonLogin"
                      onClick={handleAddPage}
                      style={{
                        margin: "0",
                        backgroundColor: "rgb(0, 189, 206)",
                        borderColor: "orange",
                        fontSize: ".6vw",
                        width: "20px",
                        height: "2vh",
                        color: "white",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {">"}
                    </button>
                  </div>
                </div>

                <div className="mobileFilters">
                  <div
                    style={{
                      marginTop: "2vh",
                      display: "flex",
                      gap: "15px",
                    }}
                  >
                    <span style={{ width: "130px" }}>
                      STR. {page}/{Math.ceil(leads.length / +perPage)}
                    </span>
                    <button
                      className="loginButtonLogin"
                      onClick={handleSubPage}
                      style={{
                        margin: "0",
                        backgroundColor: "rgb(0, 189, 206)",
                        borderColor: "orange",
                        fontSize: "3vw",
                        width: "20px",
                        height: "2vh",
                        color: "white",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {"<"}
                    </button>
                    <button
                      className="loginButtonLogin"
                      onClick={handleAddPage}
                      style={{
                        margin: "0",
                        backgroundColor: "rgb(0, 189, 206)",
                        borderColor: "orange",
                        fontSize: "3vw",
                        width: "20px",
                        height: "2vh",
                        color: "white",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {">"}
                    </button>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>

      {showEditLeadOwner ? (
        <>
          <EditLeadOwner
            leadData={editLeadOwnerId}
            close={closeEditLeadOwner}
            user={props.user.name}
            uData={props.user}
            logClientAction={props.logLeadAction}
          />
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default SellSystemLeads;
